import { render, staticRenderFns } from "./TakipInfo.vue?vue&type=template&id=7b2d8443&scoped=true"
import script from "./TakipInfo.vue?vue&type=script&lang=ts"
export * from "./TakipInfo.vue?vue&type=script&lang=ts"
import style0 from "./TakipInfo.vue?vue&type=style&index=0&id=7b2d8443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2d8443",
  null
  
)

export default component.exports